<template>
  <div class="result">
    <img class="bck pc" :src="selectedIndex == 0 ? bg_pc1 : bg_pc2" />

    <div class="result-top">
      <div class="swiper mobile">
        <img
          src="@/assets/img/swiper.jpg"
          alt=""
          class="img"
          @click="onGoActivityClick"
        />
      </div>
      <!-- <div class="research pc">
        <div class="research-button" @click="onResearch">重新查询</div>
      </div> -->
      <!-- <div class="tip pc">
        <img src="@/assets/img/top.png" alt class="top-bg" />
        <div class="tip-text">只管去迸发 为您护航</div>
      </div> -->
    </div>
    <div class="result-bottom mobile">
      <div class="tabs mobile">
        <!-- <div
          class="active-bg"
          :style="{ left: `${selectedIndex * 50}%` }"
        ></div> -->
        <div style="margin: 0 auto; width: 80%">
          <div
            class="tab-item"
            @click="onTabClick(0)"
            :style="
              selectedIndex == 0 ? { background: '#fff', color: 'black' } : {}
            "
          >
            <span class="tab-item-content">漆面膜质保卡</span>
          </div>
          <div
            class="tab-item"
            @click="onTabClick(1)"
            :style="
              selectedIndex == 1 ? { background: '#fff', color: 'black' } : {}
            "
          >
            <span class="tab-item-content">太阳膜质保卡</span>
          </div>
        </div>
      </div>

      <template v-if="selectedIndex === 1">
        <template v-if="info && info.sun && info.sun.is_empty === 0">
          <div class="info">
            <ul class="info-content">
              <li class="item">
                <div class="item-name">车主姓名：</div>
                <div class="item-value">{{ info.sun.user_name }}</div>
              </li>
              <li class="item">
                <div class="item-name">车&nbsp;&nbsp;架&nbsp;&nbsp;号：</div>
                <div class="item-value">{{ info.sun.car_sn }}</div>
              </li>
              <li class="item">
                <div class="item-name">车型名称：</div>
                <div class="item-value">{{ info.sun.car_type }}</div>
              </li>
              <li class="item">
                <div class="item-name">质保年限：</div>
                <div class="item-value">{{ info.sun.end_time }}</div>
              </li>
              <li class="item">
                <div class="item-name">车主电话：</div>
                <div class="item-value">{{ info.sun.user_phone }}</div>
              </li>
              <li class="item">
                <div class="item-name">施工时间：</div>
                <div class="item-value">{{ info.sun.start_time }}</div>
              </li>
              <li class="item">
                <div class="item-name">前挡型号：</div>
                <div class="item-value">{{ info.sun.qian_sn }}</div>
              </li>
              <li class="item">
                <div class="item-name">前挡卷号：</div>
                <div class="item-value">{{ info.sun.qian_juan_sn }}</div>
              </li>
              <li class="item">
                <div class="item-name">侧后挡型号：</div>
                <div class="item-value">{{ info.sun.hou_sn }}</div>
              </li>
              <li class="item">
                <div class="item-name">侧后挡卷号：</div>
                <div class="item-value">{{ info.sun.hou_juan_sn }}</div>
              </li>
            </ul>
          </div>
          <img
            src="@/assets/img/bg_mb2.jpg"
            style="margin-top: 0.6rem; position: relative; left: -0.4rem"
          />
        </template>
        <div class="default mobile" v-else>
          <img class="default-img" src="@/assets/img/default.png" alt />
          <div class="default-text">尚未查询到相关信息~</div>
        </div>
      </template>
      <template v-if="selectedIndex === 0">
        <template
          v-if="info && info.protected && info.protected.is_empty === 0"
        >
          <div class="info">
            <!-- <div class="info-title">
              <div class="line"></div>
              <div class="text">质保信息</div>
            </div> -->
            <ul class="info-content">
              <li class="item">
                <div class="item-name">车主姓名：</div>
                <div class="item-value">{{ info.protected.user_name }}</div>
              </li>
              <li class="item">
                <div class="item-name">车&nbsp;&nbsp;架&nbsp;&nbsp;号：</div>
                <div class="item-value">{{ info.protected.car_sn }}</div>
              </li>
              <li class="item">
                <div class="item-name">车型名称：</div>
                <div class="item-value">{{ info.protected.car_type }}</div>
              </li>
              <li class="item">
                <div class="item-name">质保年限：</div>
                <div class="item-value">{{ info.protected.end_time }}</div>
              </li>
              <li class="item">
                <div class="item-name">车主电话：</div>
                <div class="item-value">{{ info.protected.user_phone }}</div>
              </li>
              <li class="item">
                <div class="item-name">施工时间：</div>
                <div class="item-value">{{ info.protected.start_time }}</div>
              </li>
              <li class="item">
                <div class="item-name">产品卷号：</div>
                <div class="item-value">{{ info.protected.pro_sn }}</div>
              </li>
              <li class="item">
                <div class="item-name">套餐名称A：</div>
                <div class="item-value">
                  {{
                    info.protected.set_meal_name_a
                  }}
                </div>
              </li>
              <li class="item">
                <div class="item-name">套餐名称B：</div>
                <div class="item-value">
                  {{
                    info.protected.set_meal_name_b
                  }}
                </div>
              </li>
            </ul>
          </div>
          <img
            src="@/assets/img/bg_mb3.jpg"
            style="margin-top: 0.6rem; position: relative; left: -0.4rem"
          />
        </template>
        <div class="default mobile" v-else>
          <img class="default-img" src="@/assets/img/default.png" alt />
          <div class="default-text">尚未查询到相关信息~</div>
        </div>
      </template>
    </div>
    <div class="result-bottom pc">
      <div class="tabs pc">
        <div style="margin: 0 auto; width: 80%">
          <div
            class="tab-item"
            @click="onTabClick(0)"
            :style="
              selectedIndex == 0 ? { background: '#fff', color: 'black' } : {}
            "
          >
            <span class="tab-item-content">漆面膜质保卡</span>
          </div>
          <div
            class="tab-item"
            @click="onTabClick(1)"
            :style="
              selectedIndex == 1 ? { background: '#fff', color: 'black' } : {}
            "
          >
            <span class="tab-item-content">太阳膜质保卡</span>
          </div>
        </div>
      </div>

      <template v-if="selectedIndex === 1">
        <template v-if="info && info.sun && info.sun.is_empty === 0">
          <div class="info">
            <ul class="info-content">
              <li class="item">
                <div class="item-name">车主姓名：</div>
                <div class="item-value">{{ info.sun.user_name }}</div>
              </li>
              <li class="item">
                <div class="item-name">车&nbsp;&nbsp;架&nbsp;&nbsp;号：</div>
                <div class="item-value">{{ info.sun.car_sn }}</div>
              </li>
              <li class="item">
                <div class="item-name">车型名称：</div>
                <div class="item-value">{{ info.sun.car_type }}</div>
              </li>
              <li class="item">
                <div class="item-name">质保年限：</div>
                <div class="item-value">{{ info.sun.end_time }}</div>
              </li>
              <li class="item">
                <div class="item-name">车主电话：</div>
                <div class="item-value">{{ info.sun.user_phone }}</div>
              </li>
              <li class="item">
                <div class="item-name">施工时间：</div>
                <div class="item-value">{{ info.sun.start_time }}</div>
              </li>
              <li class="item">
                <div class="item-name">前挡型号：</div>
                <div class="item-value">{{ info.sun.qian_sn }}</div>
              </li>
              <li class="item">
                <div class="item-name">前挡卷号：</div>
                <div class="item-value">{{ info.sun.qian_juan_sn }}</div>
              </li>
              <li class="item">
                <div class="item-name">侧后挡型号：</div>
                <div class="item-value">{{ info.sun.hou_sn }}</div>
              </li>
              <li class="item">
                <div class="item-name">侧后挡卷号：</div>
                <div class="item-value">{{ info.sun.hou_juan_sn }}</div>
              </li>
            </ul>
          </div>
        </template>
        <div class="default pc" v-else>
          <img class="default-img" src="@/assets/img/default.png" alt />
          <div class="default-text">尚未查询到相关信息~</div>
        </div>
      </template>
      <template v-if="selectedIndex === 0">
        <template
          v-if="info && info.protected && info.protected.is_empty === 0"
        >
          <div class="info">
            <ul class="info-content">
              <li class="item">
                <div class="item-name">车主姓名：</div>
                <div class="item-value">{{ info.protected.user_name }}</div>
              </li>
              <li class="item">
                <div class="item-name">车&nbsp;&nbsp;架&nbsp;&nbsp;号：</div>
                <div class="item-value">{{ info.protected.car_sn }}</div>
              </li>
              <li class="item">
                <div class="item-name">车型名称：</div>
                <div class="item-value">{{ info.protected.car_type }}</div>
              </li>
              <li class="item">
                <div class="item-name">质保年限：</div>
                <div class="item-value">{{ info.protected.end_time }}</div>
              </li>
              <li class="item">
                <div class="item-name">车主电话：</div>
                <div class="item-value">{{ info.protected.user_phone }}</div>
              </li>
              <li class="item">
                <div class="item-name">施工时间：</div>
                <div class="item-value">{{ info.protected.start_time }}</div>
              </li>
              <li class="item">
                <div class="item-name">产品卷号：</div>
                <div class="item-value">{{ info.protected.pro_sn }}</div>
              </li>
              <li class="item">
                <div class="item-name">套餐名称A：</div>
                <div class="item-value">
                  {{
                    info.protected.set_meal_name_a
                  }}
                </div>
              </li>
              <li class="item">
                <div class="item-name">套餐名称B：</div>
                <div class="item-value">
                  {{
                    info.protected.set_meal_name_b
                  }}
                </div>
              </li>
            </ul>
          </div>
        </template>
        <div class="default pc" v-else>
          <img class="default-img" src="@/assets/img/default.png" alt />
          <div class="default-text">尚未查询到相关信息~</div>
        </div>
      </template>
      <!-- <div class="info">
        <div class="info-title">
          <div class="line"></div>
          <div class="text">汽车太阳膜质保信息</div>
          <div class="line pc"></div>
        </div>
        <ul class="info-content">
          <template v-if="info && info.sun && info.sun.is_empty === 0">
            <ul class="info-content">
              <li class="item">
                <div class="item-name">车主姓名：</div>
                <div class="item-value">{{ info.sun.user_name }}</div>
              </li>
              <li class="item">
                <div class="item-name">车架/车牌号：</div>
                <div class="item-value">{{ info.sun.car_sn }}</div>
              </li>
              <li class="item">
                <div class="item-name">车型名称：</div>
                <div class="item-value">{{ info.sun.car_type }}</div>
              </li>
              <li class="item">
                <div class="item-name">质保年限：</div>
                <div class="item-value">{{ info.sun.end_time }}</div>
              </li>
              <li class="item">
                <div class="item-name">车主电话：</div>
                <div class="item-value">{{ info.sun.user_phone }}</div>
              </li>
              <li class="item">
                <div class="item-name">施工时间：</div>
                <div class="item-value">{{ info.sun.start_time }}</div>
              </li>
              <li class="item">
                <div class="item-name">前挡型号：</div>
                <div class="item-value">{{ info.sun.qian_sn }}</div>
              </li>
              <li class="item">
                <div class="item-name">前挡卷号：</div>
                <div class="item-value">{{ info.sun.qian_juan_sn || " " }}</div>
              </li>
              <li class="item">
                <div class="item-name">侧后挡型号：</div>
                <div class="item-value">{{ info.sun.hou_sn }}</div>
              </li>
              <li class="item">
                <div class="item-name">侧后挡卷号：</div>
                <div class="item-value">{{ info.sun.hou_juan_sn }}</div>
              </li>
            </ul>
          </template>
          <div class="default pc" v-else>
            <img class="default-img" src="@/assets/img/default.png" alt />
            <div class="default-text">尚未查询到相关信息~</div>
          </div>
        </ul>
      </div>
      <div class="info">
        <div class="info-title">
          <div class="line"></div>
          <div class="text">漆面养护膜质保信息</div>
          <div class="line pc"></div>
        </div>
        <ul class="info-content">
          <template
            v-if="info && info.protected && info.protected.is_empty === 0"
          >
            <ul class="info-content">
              <li class="item">
                <div class="item-name">车主姓名：</div>
                <div class="item-value">{{ info.protected.user_name }}</div>
              </li>
              <li class="item">
                <div class="item-name">车架/车牌号：</div>
                <div class="item-value">{{ info.protected.car_sn }}</div>
              </li>
              <li class="item">
                <div class="item-name">车型名称：</div>
                <div class="item-value">{{ info.protected.car_type }}</div>
              </li>
              <li class="item">
                <div class="item-name">质保年限：</div>
                <div class="item-value">{{ info.protected.end_time }}</div>
              </li>
              <li class="item">
                <div class="item-name">车主电话：</div>
                <div class="item-value">{{ info.protected.user_phone }}</div>
              </li>
              <li class="item">
                <div class="item-name">施工时间：</div>
                <div class="item-value">{{ info.protected.start_time }}</div>
              </li>
              <li class="item">
                <div class="item-name">产品卷号：</div>
                <div class="item-value">{{ info.protected.pro_sn }}</div>
              </li>
            </ul>
          </template>
          <div class="default pc" v-else>
            <img class="default-img" src="@/assets/img/default.png" alt />
            <div class="default-text">尚未查询到相关信息~</div>
          </div>
        </ul>
      </div>
      <div
        class="info taocan"
        v-if="
          info &&
          info.protected &&
          (info.protected.set_meal_name_a || info.protected.set_meal_name_a)
        "
      >
        <div class="info-title">
          <div class="line"></div>
          <div class="text">所购买漆面养护膜套餐</div>
        </div>
        <ul class="info-content">
          <li class="item-label" v-if="info.protected.set_meal_name_a">
            <span class="item-label-icon">
              <img src="@/assets/img/icon-1.png" alt />
            </span>
            <span class="item-label-text">{{
              info.protected.set_meal_name_a
            }}</span>
          </li>
          <li class="item-label" v-if="info.protected.set_meal_name_b">
            <span class="item-label-icon">
              <img src="@/assets/img/icon-2.png" alt />
            </span>
            <span class="item-label-text">{{
              info.protected.set_meal_name_b
            }}</span>
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</template>

<script>
import API from "./api";
export default {
  components: {
  },
  data() {
    return {
      info: null,
      selectedIndex: 0,
      mbMobileBanner: [],
      canBannerClick: false,
      bg_pc1: require('../../assets/img/bg_pc2.jpg'),
      bg_pc2: require('../../assets/img/bg_pc3.jpg'),
    };
  },
  methods: {
    // get_pic() {
    //   API.get_pic({
    //     type: 3
    //   }, res => {
    //     if (res && res.code) {
    //       let list = []
    //       Object.keys(res.data).forEach(key => {
    //         list.push(res.data[key])
    //       })
    //       this.$set(this, 'mbMobileBanner', list)
    //     }
    //   })
    // },
    onGoActivityClick() {
      this.$router.push({
        name: "activity",
        params: {}
      });
    },
    onTabClick(index) {
      this.selectedIndex = index;
    },
    onResearch() {
      this.$router.push({ name: "search" });
    }
  },
  mounted() {
    let info = this.$route.params.info;
    // // 测试
    // info = {
    //   sun: {
    //     id: 2,
    //     user_phone: "13735474850",
    //     user_name: "测试姓名",
    //     car_sn: "1234",
    //     car_type: "兰博基尼",
    //     start_time: "2020/01/17",
    //     end_time: "2020/01/17",
    //     qian_sn: "1234",
    //     hou_sn: "1234",
    //     mo_type: 0,
    //     is_empty: 0,
    //     city: '杭州'
    //   },
    //   protected: {
    //     id: 1,
    //     user_phone: "13735474850",
    //     user_name: "测试姓名",
    //     car_sn: "1234",
    //     car_type: "兰博基尼",
    //     start_time: "2020/01/17",
    //     end_time: "2020/01/17",
    //     set_meal_name_a: "豪华套餐",
    //     set_meal_name_b: "总统套餐",
    //     pro_sn: "1231",
    //     mo_type: 1,
    //     is_empty: 0
    //   }
    // };
    if (!info) {
      let s = sessionStorage.getItem("qichemo") || "{}";
      info = JSON.parse(s);
    }
    sessionStorage.setItem("qichemo", JSON.stringify(info));
    this.$set(this, "info", info);
    // this.canBannerClick = this.info && this.info.sun && this.info.sun.city === '杭州市'
    // if (this.canBannerClick) {
    //   this.get_pic()
    // } else {
    //   const list = [
    //     require('@/assets/img/swiper1-old.jpg'),
    //     require('@/assets/img/swiper2-old.jpg'),
    //     require('@/assets/img/swiper3-old.jpg')
    //   ]
    //   this.$set(this, 'mbMobileBanner', list)
    // }
  }
};
</script>

<style scoped lang="scss">
.result {
  width: 100%;
  height: 100%;
  // overflow: hidden;
}
.result .result-top {
  width: 100%;
  position: relative;
}
@media screen and (min-width: 100px) and (max-width: 640px) {
  .result .pc {
    display: none !important;
  }
  .result .result-top {
    height: 2.4rem;
    text-align: center;
    overflow: hidden;
  }
  .result .result-top .swiper {
    width: 100%;
    height: 2.4rem;
    position: relative;
  }
  .result .result-top .swiper .img {
    height: calc(100%);
    width: calc(100%);
  }
  .result .result-top .swiper .activity {
    height: calc(100%);
    width: auto;
    position: absolute;
    right: 0.2rem;
    top: 0;
  }
  .result .result-bottom {
    padding: 0 0.24rem 0.24rem;
  }
  .result .result-bottom .tabs {
    width: 7.02rem;
    height: 0.98rem;
    position: relative;
    margin-top: 0.48rem;
    text-align: center;
    background: linear-gradient(
      to top,
      rgb(102, 100, 100) 0%,
      rgb(239, 236, 236) 100%
    );
    box-shadow: 0px 6px 20px 0px rgba(23, 23, 23, 0.25);
    border-radius: 0.1rem;
  }
  .result .result-bottom .tabs .tab-item {
    width: 50%;
    height: 0.98rem;
    // border-left: 0.1rem solid black;
    // border-right: 0.1rem solid black;
    background: #e0dddd;
    box-sizing: border-box;
    transform: skew(-20deg);
    -webkit-transform: skew(-20deg);
    -moz-transform: skew(-20deg);
    -o-transform: skew(-20deg);
    -ms-transform: skew(-20deg);
    display: inline-block;
    font-size: 0.3rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #fff;
    line-height: 0.98rem;
    text-align: center;
  }
  .result .result-bottom .tabs .tab-item .tab-item-content {
    display: inline-block;
    transform: skew(20deg);
    -webkit-transform: skew(20deg);
    -moz-transform: skew(20deg);
    -o-transform: skew(20deg);
    -ms-transform: skew(20deg);
  }
  .result .result-bottom .tabs .tab-item:first-child {
    left: 0;
  }
  .result .result-bottom .tabs .tab-item:last-child {
    left: 50%;
  }
  .result .result-bottom .tabs .active-bg {
    width: 50%;
    height: 0.98rem;
    position: absolute;
    top: 0;
    border-radius: 0.49rem;
    background: linear-gradient(
      0deg,
      rgba(199, 41, 51, 1) 0%,
      rgba(222, 133, 140, 1) 100%
    );
    transition: left 0.2s;
    -webkit-transition: left 0.2s; /* Safari */
  }
  .result .result-bottom .info {
    margin-top: 0.36rem;
  }
  .result .result-bottom .info .info-title {
    height: 0.29rem;
  }
  .result .result-bottom .info .info-title > div {
    display: inline-block;
  }
  .result .result-bottom .info .info-title .line {
    width: 0.07rem;
    height: 0.2rem;
    margin-top: 0.04rem;
    background: rgba(21, 21, 21, 1);
    border-radius: 0.04rem;
  }
  .result .result-bottom .info .info-title .text {
    width: 2rem;
    height: 0.29rem;
    margin-left: 0.24rem;
    font-size: 0.3rem;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    line-height: 0.29rem;
  }
  .result .result-bottom .info .info-content {
    width: 7rem;
    margin: 0.35rem auto 0;
  }
  .result .result-bottom .info .info-content .item {
    width: 100%;
    height: 0.64rem;
    margin-top: 0.24rem;
    background: linear-gradient(
      to top,
      rgb(180, 178, 178) 0%,
      rgb(255, 255, 255) 100%
    );
    box-shadow: 0 0.01rem 0.3rem 0 rgba(204, 204, 204, 0.35);
    border-radius: 0.1rem;
  }
  .result .result-bottom .info .info-content .item > div {
    display: inline-block;
  }
  .result .result-bottom .info .info-content .item > .item-name {
    width: 1.6rem;
    height: 0.64rem;
    font-size: 0.24rem;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    line-height: 0.64rem;
    opacity: 0.7;
    text-align: right;
    vertical-align: top;
  }
  .result .result-bottom .info .info-content .item > .item-value {
    width: 3rem;
    height: 0.64rem;
    box-sizing: border-box;
    padding-left: 0.6rem;
    line-height: 0.64rem;
    font-size: 0.24rem;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    opacity: 0.9;
    text-align: left;
    white-space: nowrap;
  }
  .result .result-bottom .default .default-img {
    width: 2.5rem;
    height: 1.97rem;
    margin: 0.65rem auto 0;
  }
  .result .result-bottom .default .default-text {
    width: 100%;
    height: 0.23rem;
    margin-top: 0.27rem;
    font-size: 0.24rem;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    opacity: 0.4;
    text-align: center;
  }
}
// @media screen and (min-width: 641px) {
//   .result .mobile {
//     display: none !important;
//   }
//   .result .research {
//     width: 100%;
//     height: 60px;
//     background: rgba(223, 232, 237, 1);
//   }
//   .result .research .research-button {
//     width: 120px;
//     height: 36px;
//     float: right;
//     margin-top: 15px;
//     margin-right: 36px;
//     background: linear-gradient(
//       90deg,
//       rgba(203, 56, 65, 1),
//       rgba(211, 90, 96, 1)
//     );
//     box-shadow: 0px 6px 20px 0px rgba(204, 59, 68, 0.75);
//     border-radius: 18px;
//     font-size: 16px;
//     font-family: Microsoft YaHei;
//     font-weight: bold;
//     color: rgba(255, 255, 255, 1);
//     line-height: 36px;
//     text-align: center;
//     cursor: pointer;
//   }
//   .result .tip {
//     width: 1200px;
//     height: 120px;
//     margin: 48px auto 0;
//     background: rgba(48, 59, 69, 1);
//     opacity: 0.8;
//     border-radius: 60px;
//     position: relative;
//   }
//   .result .tip .tip-bg,
//   .result .tip .tip-text {
//     position: absolute;
//     left: 0;
//     top: 0;
//     width: 100%;
//     height: 100%;
//   }
//   .result .tip .tip-text {
//     font-size: 36px;
//     font-family: Microsoft YaHei;
//     font-weight: bold;
//     color: rgba(255, 255, 255, 1);
//     line-height: 120px;
//     text-align: center;
//   }

//   .result .result-bottom {
//     margin-top: 83px;
//     padding-bottom: 100px;
//   }
//   .result .result-bottom .info {
//     margin-top: 63px;
//   }
//   .result .result-bottom .info.taocan {
//     margin-top: 35px;
//   }
//   .result .result-bottom .info .info-title {
//     height: 19px;
//     text-align: center;
//   }
//   .result .result-bottom .info .info-title > div {
//     display: inline-block;
//   }
//   .result .result-bottom .info .info-title .line {
//     width: 22px;
//     height: 5px;
//     background: rgba(202, 53, 62, 1);
//     border-radius: 3px;
//     vertical-align: text-top;
//     margin-top: 7px;
//   }
//   .result .result-bottom .info .info-title .line:last-child {
//     margin-left: 16px;
//   }
//   .result .result-bottom .info .info-title .text {
//     font-size: 18px;
//     font-family: Microsoft YaHei;
//     font-weight: bold;
//     color: rgba(0, 0, 0, 1);
//     line-height: 19px;
//     opacity: 0.9;
//     vertical-align: text-top;
//     margin-left: 16px;
//   }
//   .result .result-bottom .info .info-content {
//     width: 531px;
//     margin: 36px auto 0;
//   }
//   .result .result-bottom .info .info-content .item {
//     width: 100%;
//     height: 36px;
//     margin-top: 16px;
//     background: rgba(240, 240, 240, 1);
//     box-shadow: 0px 1px 20px 0px rgba(204, 204, 204, 0.3);
//     border-radius: 18px;
//   }
//   .result .result-bottom .info .info-content .item > div {
//     display: inline-block;
//     height: 100%;
//   }
//   .result .result-bottom .info .info-content .item > .item-name {
//     width: 185px;
//     font-size: 14px;
//     font-family: Microsoft YaHei;
//     font-weight: 400;
//     color: rgba(0, 0, 0, 1);
//     line-height: 36px;
//     opacity: 0.7;
//     text-align: right;
//   }
//   .result .result-bottom .info .info-content .item > .item-value {
//     width: 320px;
//     font-size: 14px;
//     float: right;
//     font-family: Microsoft YaHei;
//     font-weight: bold;
//     color: rgba(0, 0, 0, 1);
//     line-height: 36px;
//     opacity: 0.7;
//     text-align: left;
//     white-space: nowrap;
//   }

//   .result .result-bottom .info .info-content .item-label {
//     width: 200px;
//     height: 20px;
//     display: inline-block;
//     margin-top: 20px;
//   }
//   .result .result-bottom .info .info-content .item-label:first-child,
//   .result .result-bottom .info .info-content .item-label:nth-child(2) {
//     margin-top: 0;
//   }
//   .result .result-bottom .info .info-content .item-label {
//     margin-left: 62px;
//   }
//   .result .result-bottom .info .info-content .item-label .item-label-icon {
//     width: 20px;
//     height: 20px;
//     display: inline-block;
//     vertical-align: text-bottom;
//   }
//   .result .result-bottom .info .info-content .item-label .item-label-icon img {
//     width: 20px;
//     height: 20px;
//     vertical-align: text-bottom;
//   }
//   .result .result-bottom .info .info-content .item-label .item-label-text {
//     margin-left: 7px;
//     font-size: 14px;
//     font-family: Microsoft YaHei;
//     font-weight: bold;
//     color: rgba(0, 0, 0, 1);
//     line-height: 20px;
//     opacity: 0.7;
//   }

//   .result .result-bottom .default .default-img {
//     width: 210px;
//     height: 166px;
//     margin: 41px auto 0;
//   }
//   .result .result-bottom .default .default-text {
//     width: 100%;
//     font-size: 16px;
//     font-family: Microsoft YaHei;
//     font-weight: 400;
//     color: rgba(0, 0, 0, 1);
//     opacity: 0.4;
//     text-align: center;
//   }
// }
@media screen and (min-width: 641px) {
  .result {
    overflow: hidden;
  }
  .result .mobile {
    display: none !important;
  }
  .result-top {
    display: none;
  }
  .bck {
    width: 100%;
    z-index: 0;
  }
  // .result .result-top {
  //   height: 2.4rem;
  //   text-align: center;
  //   overflow: hidden;
  // }
  // .result .result-top .swiper {
  //   width: 100%;
  //   height: 2.4rem;
  //   position: relative;
  // }
  // .result .result-top .swiper .img {
  //   height: calc(100%);
  //   width: calc(100%);
  // }
  // .result .result-top .swiper .activity {
  //   height: calc(100%);
  //   width: auto;
  //   position: absolute;
  //   right: 0.2rem;
  //   top: 0;
  // }
  .result .result-bottom {
    // padding: 0 0.24rem 0.24rem;
    background: rgba(194, 193, 193, 0.475);
    width: 400px;
    position: absolute;
    top: 18%;
    left: 50%;
    border-radius: 5px;
  }
  .result .result-bottom .tabs {
    width: 100%;
    height: 50px;
    position: relative;
    text-align: center;
    background: linear-gradient(
      to top,
      rgb(102, 100, 100) 0%,
      rgb(239, 236, 236) 100%
    );
    box-shadow: 0px 6px 20px 0px rgba(23, 23, 23, 0.25);
    border-radius: 5px;
  }
  .result .result-bottom .tabs .tab-item {
    width: 50%;
    height: 50px;
    display: inline-block;
    transform: skew(-20deg);
    -webkit-transform: skew(-20deg);
    -moz-transform: skew(-20deg);
    -o-transform: skew(-20deg);
    -ms-transform: skew(-20deg);
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    background: #e0dddd;
    color: rgba(255, 255, 255, 1);
    line-height: 50px;
    text-align: center;
  }
  .result .result-bottom .tabs .tab-item .tab-item-content {
    display: inline-block;
    transform: skew(20deg);
    -webkit-transform: skew(20deg);
    -moz-transform: skew(20deg);
    -o-transform: skew(20deg);
    -ms-transform: skew(20deg);
    cursor: pointer;
  }
  .result .result-bottom .tabs .tab-item:first-child {
    left: 0;
  }
  .result .result-bottom .tabs .tab-item:last-child {
    left: 50%;
  }
  // .result .result-bottom .tabs .active-bg {
  //   width: 50%;
  //   height: 0.98rem;
  //   position: absolute;
  //   top: 0;
  //   border-radius: 0.49rem;
  //   background: linear-gradient(
  //     0deg,
  //     rgba(199, 41, 51, 1) 0%,
  //     rgba(222, 133, 140, 1) 100%
  //   );
  //   transition: left 0.2s;
  //   -webkit-transition: left 0.2s; /* Safari */
  // }
  // .result .result-bottom .info {
  //   margin-top: 0.36rem;
  // }
  // .result .result-bottom .info .info-title {
  //   height: 0.29rem;
  // }
  // .result .result-bottom .info .info-title > div {
  //   display: inline-block;
  // }
  // .result .result-bottom .info .info-title .line {
  //   width: 0.07rem;
  //   height: 0.2rem;
  //   margin-top: 0.04rem;
  //   background: rgba(21, 21, 21, 1);
  //   border-radius: 0.04rem;
  // }
  // .result .result-bottom .info .info-title .text {
  //   width: 2rem;
  //   height: 0.29rem;
  //   margin-left: 0.24rem;
  //   font-size: 0.3rem;
  //   font-family: PingFang SC;
  //   font-weight: 600;
  //   color: rgba(0, 0, 0, 1);
  //   line-height: 0.29rem;
  // }
  .result .result-bottom .info .info-content {
    width: 400px;
    margin: 20px auto 0;
  }
  .result .result-bottom .info .info-content .item {
    width: 100%;
    height: 40px;
    margin-top: 10px;
    background: rgba(240, 240, 240, 1);
    // box-shadow: 0 0.01rem 0.3rem 0 rgba(204, 204, 204, 0.35);
    border-radius: 5px;
  }
  .result .result-bottom .info .info-content .item > div {
    display: inline-block;
  }
  .result .result-bottom .info .info-content .item > .item-name {
    width: 100px;
    height: 40px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    line-height: 40px;
    opacity: 0.7;
    text-align: right;
    vertical-align: top;
  }
  .result .result-bottom .info .info-content .item > .item-value {
    width: 280px;
    height: 40px;
    box-sizing: border-box;
    padding-left: 20px;
    line-height: 40px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    opacity: 0.9;
    text-align: left;
    white-space: nowrap;
  }
  .result .result-bottom .default .default-img {
    width: 130px;
    height: 100px;
    margin: 130px auto 0;
  }
  .result .result-bottom .default .default-text {
    width: 100%;
    height: 130px;
    margin-top: 40px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    opacity: 0.4;
    text-align: center;
  }
}
</style>
